import clsx from 'clsx';

const VARIANTS = {
  income: 'bg-success-50 text-success-700 dark:bg-success-500/10 dark:text-success-500',
  expense: 'bg-danger-50 text-danger-700 dark:bg-danger-500/10 dark:text-danger-500',
  neutral: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300',
  warning: 'bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-500',
};

export default function Badge({ children, variant = 'neutral', className }) {
  return (
    <span
      className={clsx(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        VARIANTS[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
